module.exports = __webpack_public_path__ + "static/images/2_cloudy_navigate_night.ce207f4a.jpg";